import React from 'react';
import { Button, Menu, MenuItem, ListItemText, ListItemIcon } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import SendMessagePreviewModal from './SendMessagePreviewModal';
import toast from 'react-hot-toast';
import { sendApplicationMail } from '../../../../../../services/request';
import { useParameterizedQuery } from 'react-fetching-library';
import { useApplication } from '../../../ApplicationsContext';


export const EmailButton = () => {
  const { rowData } = useApplication();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [openModal, setOpenModal] = React.useState(false);
  const [notificationType, setNotificationType] = React.useState();

  const { query: sendApplicationEmailQuery } = useParameterizedQuery(sendApplicationMail);


  const handleSend = async data => {
    const { error, loading } = await sendApplicationEmailQuery(rowData.id, data);
    if (!error && !loading) {
      toast.success('Email został wysłany');
      setOpenModal(false);
    }

    if (error) {
      toast.error('Nie udało się wysłać emaila');
    }
  };

  const handleOpen = type => {
    setNotificationType(type);
    setOpenModal(true);
  };

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        id="basic-button"
        disabled={false}
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="contained"
        onClick={handleClick}
      >
        <EmailIcon sx={{ mr: 2 }}/>
        Wyślij e-mail
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        <MenuItem onClick={() => handleOpen('SDSS')}>
          <ListItemIcon>
            <EmailIcon />
          </ListItemIcon>
          <ListItemText>
              Wyślij statusy dokumentów
          </ListItemText>
        </MenuItem>
      </Menu>
      {openModal
        ? <SendMessagePreviewModal
          handleSend={handleSend}
          handleClose={() => setOpenModal(false)}
          type={notificationType}
        />
        : null}
    </>
  );
};
